<div *ngIf="dataUser || showDetailUser == true" id="userDetail">
    <section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
        <section class="container admin-dashboard-details professionals-details-container">
            <section class="template-section-title">
                <div class="breadcrumb-container">
                    <span>Admin <i class="fa fas fa-chevron-right"></i></span>
                    <app-breadcrumb [pageName]="'Unlock Request'" [isTopLevel]="true"></app-breadcrumb>
                </div>
                <div class="title-container">
                    <h1>Unlock Request Details</h1>
                </div>
            </section>
            <div class="notification-bubble-container">
                <app-notification-bubble></app-notification-bubble>
            </div>
            <section class="user-dashboard">
                <div class="user-name">
                    <h2 class="user-name">
                        {{ firstName + " " + lastName}} - {{ email }}
                    </h2>
                </div>
            </section>
            <section class="all-users-data">
                <section class="table-responsive admin-dashboard-table">
                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th scope="col">First Name</th>
                                <th scope="col">Last Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Phone Number</th>
                                <th scope="col">Relation To Owner</th>
                                <th scope="col">Choice Report</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="body-header">
                                <td *ngIf="dataUser.data.firstName">{{dataUser.data.firstName}}</td>
                                <td *ngIf="!dataUser.data.firstName">--</td>
                                <td *ngIf="dataUser.data.lastName">{{dataUser.data.lastName}}</td>
                                <td *ngIf="!dataUser.data.lastName">--</td>
                                <td *ngIf="dataUser.data.email">{{dataUser.data.email}}</td>
                                <td *ngIf="!dataUser.data.email">--</td>
                                <td *ngIf="dataUser.data.phoneNumber">{{dataUser.data.phoneNumber}}</td>
                                <td *ngIf="!dataUser.data.phoneNumber">--</td>
                                <td *ngIf="dataUser.data.relationToOwner">{{dataUser.data.relationToOwner}}</td>
                                <td *ngIf="!dataUser.data.relationToOwner">--</td>
                                <td *ngIf="dataUser.data.choiceReport">{{dataUser.data.choiceReport}}</td>
                                <td *ngIf="!dataUser.data.choiceReport">--</td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <app-file-attachment [filePlanId]="user" [readOnly]="true" [attachments]="dataUser.attachments"></app-file-attachment>
            </section>
            <input type="button" class="btn btn-primary back-btn" value="Back" (click)="goBack()">
            <input type="button" class="btn btn-success allow-request" value="Allow" (click)="allowRequest()">
            <input type="button" class="btn btn-danger deny-request" value="Deny" (click)="denyRequest()">
        </section>
    </section>
</div>